import React from 'react';
import PropTypes from 'prop-types';
import Choice from './choice';

const Question = ({ question, questionNo, handleChange }) => {
  return (
    <div className={`quiz-item quiz-item--${questionNo}`}>
      <div className="question">
        <span className="question-number">Q{questionNo}</span>
        <span className="question-text">{question.question}</span>
      </div>
      <div className="options">
        {question.options &&
          question.options.map((option, index) => (
            <Choice
              key={`${index}-${questionNo}`}
              option={option}
              questionNo={questionNo}
              value={index + 1}
              handleChange={handleChange}
            />
          ))}
      </div>
    </div>
  );
};
Question.propTypes = {
  question: PropTypes.shape({
    question: PropTypes.string,
    option: PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
    }),
  }),
  questionNo: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
};
export default Question;
